import { getConditionalObject } from 'utils/data';

export const getTableCellStyles = ({ customStyles, isFullWidthDivider }) => ({
  border: 0,
  padding: '6px 0',
  '&:first-of-type': {
    color: ({ palette }) => palette.text.dark,
    ...getConditionalObject(isFullWidthDivider, {
      paddingLeft: '24px',
    }),
  },
  '&:last-of-type': {
    ...getConditionalObject(isFullWidthDivider, {
      paddingRight: '24px',
    }),
  },

  ...customStyles,
});

export const getTableCellPendingChangesStyles = ({ isModified }) => ({
  float: 'right',
  ...getConditionalObject(isModified, {
    marginRight: '-4px',
  }),
});
